let popupevent = {
    init() {
        //COOKIES
        function setCookie(name,value,days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days*24*60*60*1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + (value || "")  + expires + "; path=/";
        }

        function getCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for(var i=0;i < ca.length;i++) {
                var c = ca[i];
                while (c.charAt(0)==' ') c = c.substring(1,c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
            }
            return null;
        }

        function eraseCookie(name) {
            document.cookie = name + '=;expires=Thu, 01 Jan 2025 00:00:01 GMT;';
        }

        if(!getCookie('event') && $('body').hasClass('event-actif')){
            setTimeout(() => {
                $('.popup-event').fadeIn(300);
                $('body').addClass('noscroll');
            }, 30000);
        }

        $(document).click(function(event) {
            if ( $(event.target).hasClass('popup-event')) {
                $(".popup-event").fadeOut(300);
                $('body').removeClass('noscroll');
                setCookie('event', 1);
            }
        });
        $('.popup-event .close, .popup-event .btn').click(function(){
            $(".popup-event").fadeOut(300);
            $('body').removeClass('noscroll');
            setCookie('event', 1);
        })

    }
}

export default popupevent;

